<template>
  <div>
    <section>
      <input type="checkbox" id="check" />
      <header :class="{ scrolling: scrollPosition > 50 }">
        <span class="left_area icon">
          <img
            src="../../assets/static/icons/expar_logo_new.svg"
            alt="expar_logo"
          />
          <span class="logo-text"> expar </span>
        </span>
        <div class="navigation" v-bind:class="{ active: isActive }">
          <a data-qa="useCaseLink" href="#useCase">{{ $t('useCases') }}</a>
          <a data-qa="featuresLink" href="#features">{{ $t('features') }}</a>
          <a data-qa="pricingLink" href="#pricing">{{ $t('pricing') }}</a>
          <a data-qa="faqLink" href="#FAQ">{{ $t('faq') }}</a>
          <router-link
            data-qa="loginButton"
            class="login-btn"
            :to="{}"
            @click.native="
              $gtag.event('open-login-modal', { method: 'Google' })
              $parent.resetLoginModalErrors()
              $bvModal.show('login-modal')
            "
            >{{ $t('login') }}</router-link
          >
          <a data-qa="freeTrialButton" class="trial-btn" href="#pricing"
            >30-{{ $t('daysfreeTrial') }}</a
          >
          <language-switcher style="color: #ffffff" />
        </div>
        <label for="check">
          <font-awesome-icon id="menu-btn" :icon="['fas', 'bars']" />
          <font-awesome-icon id="close-btn" :icon="['fas', 'times']" />
        </label>
      </header>
      <div class="content">
        <div class="info">
          <h2>
            {{ $t('slogan1') }} <br /><span>{{ $t('slogan2') }}</span>
          </h2>
          <p>
            {{ $t('statement1') }} <br />
            {{ $t('statement2') }}
          </p>
          <div class="ctaButtons">
            <a href="#pricing" data-qa="moreInfoButton" class="info-btn hideMobile">{{
              $t('moreInfo')
            }}</a>
            <a href="mailto:ziga.coz@linking-map.com" data-qa="moreInfoButton" class="info-btn">{{
              $t('contactUs')
            }}</a>            
          </div>
        </div>
      </div>
      <a class="cta-btn mobileOnly" href="#pricing">
        30-{{ $t('daysfreeTrial') }}
      </a>
      <div class="media-icons">
        <a data-qa="fbButton" target="_blank" href="https://www.facebook.com/exparstore/"
          ><font-awesome-icon :icon="['fab', 'facebook-f']"
        /></a>
        <a data-qa="liButton" target="_blank" href="https://www.linkedin.com/company/expar-store/"
          ><font-awesome-icon :icon="['fab', 'linkedin-in']"
        /></a>
        <a data-qa="instaButton" target="_blank" href="https://www.instagram.com/expar.store/"
          ><font-awesome-icon :icon="['fab', 'instagram']"
        /></a>
        <a data-qa="emailButton" href="mailto:info@expar-store.com"
          ><font-awesome-icon :icon="['fas', 'envelope']"
        /></a>
      </div>
    </section>
  </div>
</template>

<script>
import LanguageSwitcher from '../common/LanguageSwitcher.vue'

export default {
  components: { LanguageSwitcher },

  data: function () {
    return {
      isActive: false,
      scrollPosition: 0,
      subscriptionPlan: 'month',
      planDetails: {},
      selectedPlan: null,
    }
  },
  async mounted() {
    window.addEventListener('scroll', this.handleTopBar)
    const planList = await this.$store.dispatch('fetchSubscriptionPlanDetails')
    planList.forEach((item, index) => {
      this.planDetails[planList[index]['interval']] = item
    })
    this.selectedPlan = this.planDetails[this.subscriptionPlan]
  },
  methods: {
    handleTopBar() {
      this.scrollPosition = window.scrollY
    },
    scrollToTrial() {
      this.$emit('scroll-subscription', {})
    },
    sendSubscriptionDetails() {
      this.$emit('subscription-data', {
        amount: (this.selectedPlan.price / 100) * this.unitCount,
        unit_count: this.unitCount,
        currency: 'eur',
        subscription_plan:
          this.subscriptionPlan === 'month' ? 'monthly' : 'yearly',
        price_id: this.selectedPlan.id,
        storage_value: this.maxDataStorage * this.unitCount,
        storage_unit: 'MB',
        status: 'trial',
      })
    },
  },
}
</script>

<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* font-family: 'Playfair Display', Helvetica, Arial; */
}

section {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* background: linear-gradient(192deg, rgba(12,46,68,1) 43%, rgba(123,78,91,1) 100%); */
  background: url('../../assets/static/images/bg/landing_header.jpg') no-repeat;
  background-size: cover;
  background-position: center;
}

header {
  position: fixed;
  top: 0;
  width: 100%;
  padding: 30px 10px 30px 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

header .logo {
  position: relative;
  color: #000;
  font-size: 30px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 800;
  letter-spacing: 1px;
}

header .navigation a {
  color: var(--bright);
  text-decoration: none;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 4px 15px;
  border-radius: 20px;
  transition: 0.3s;
  transition-property: background;
}

header .navigation a:not(:last-child) {
  margin-right: 10px;
}

header .navigation a:hover {
  background: #fff;
}

.left_area img {
  width: 15%;
  padding: 5px;
}

.left_area span {
  font-family: 'Nasalization', Helvetica, Arial;
  color: var(--white);
  font-size: 2.5rem;
  letter-spacing: 2px;
  font-weight: 500;
  margin-left: 2px;
}

.ctaButtons a {
  margin: 2rem;
}

.icon {
  vertical-align: middle;
  display: inherit;
}
.logo-text {
  vertical-align: middle;
  display: inherit;
  margin: auto;
}

.scrolling {
  background-color: var(--bg);
  background-size: cover;
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 1s;
  padding: 15px 10px 15px 15px;
}

.content {
  max-width: 750px;
  margin: 300px 100px;
}

.content .info {
  background-color: var(--bg-light) !important;
  padding: 20px;
}

.content .info h2 {
  text-align: left;
  color: var(--primary);
  font-size: 55px;
  text-transform: uppercase;
  font-weight: 900;
  letter-spacing: 2px;
  line-height: 60px;
  margin-bottom: 30px;
}

.content .info h2 span {
  color: #fff;
  font-size: 50px;
  font-weight: 600;
}

.content .info p {
  color: #fff;
  font-size: 30px;
  text-align: justify;
  font-weight: 500;
  margin-bottom: 40px;
}
.navigation .trial-btn {
  color: #fff;
  background: var(--primary);
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.navigation .trial-btn:hover {
  background: #0c4f60;
}
.navigation .login-btn {
  color: var(--primary) !important;
  border: 1px solid var(--primary);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.navigation .login-btn:hover {
  background: var(--primary);
  color: var(--bright) !important;
}
header .navigation a:hover {
  color: var(--primary) !important;
}
.info-btn {
  color: var(--primary) !important;
  border: 1px solid var(--primary);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.info-btn:hover {
  background: var(--primary);
  color: var(--bright) !important;
}
.check {
  color: var(--br) !important;
}

.cta-btn {
  color: #fff;
  background: var(--primary);
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
  margin: auto;
  width: 250px;
}

.cta-btn:hover {
  background: #0c4f60;
}

.media-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-bottom: 50px;
}

.media-icons a {
  position: relative;
  color: var(--bright);
  font-size: 25px;
  transition: 0.3s;
  transition-property: transform;
}

.media-icons a:not(:last-child) {
  margin-right: 60px;
}

.media-icons a:hover {
  transform: scale(1.5);
  color: var(--primary);
}

label {
  display: none;
  color: white;
}

#check {
  z-index: 3;
  display: none;
}

.footerColumn {
  text-align: left;
}
footer h5 {
  padding-left: 24px;
}
/* Responsive styles */

@media (max-width: 1650px) {
  header .navigation a {
    margin-right: 3px;
  }
}

@media (max-width: 1100px) {
  section {
    /* background: linear-gradient(193deg, rgba(12,46,68,1) 0%, rgba(61,88,105,1) 28%, rgba(96,93,108,1) 64%, rgba(251,115,119,1) 100%); */
    background: url('../../assets/static/images/bg/landing_header_mobile.jpg')
      no-repeat;
    background-size: cover;
    background-position: center;
  }
  .logo {
    left: 0;
  }
  header .navigation a {
    margin-right: 0px;
    padding: 2px 5px;
  }
  .navigation .trial-btn {
    letter-spacing: 0px;
    padding: 10px 2px;
  }
}

@media (max-width: 960px) {
  header {
    padding: 30px 10px;
  }

  header .navigation {
    display: none;
  }

  .navigation .trial-btn {
    letter-spacing: 1px;
    padding: 10px 20px;
  }

  label {
    display: block;
    font-size: 25px;
    cursor: pointer;
    transition: 0.05s;
    transition-property: color;
    margin-right: 10px;
    padding: 10px;
  }

  label:hover {
    color: var(--primary);
  }

  label #close-btn {
    display: none;
  }

  label #close-btn #menu_btn {
  }

  #check:checked ~ header .navigation {
    z-index: 2;
    position: fixed;
    background: rgba(44, 62, 80, 0.9);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  #check:checked ~ header .navigation a {
    font-weight: 700;
    margin-right: 0;
    margin-bottom: 50px;
    letter-spacing: 2px;
  }
  #check:checked ~ header label #menu-btn {
    display: none;
  }
  #check:checked ~ header label #close-btn {
    z-index: 2;
    display: block;
    position: fixed;
    right: 30px;
    top: 20px;
  }
  label .menu-btn {
    position: absolute;
  }
  header .logo {
    position: absolute;
    bottom: 30px;
  }
  .content .info h2 {
    font-size: 45px;
    line-height: 50px;
  }
  .content .info h2 span {
    font-size: 40px;
    font-weight: 600;
  }
  .content .info p {
    font-size: 18px;
    text-align: left;
  }
  .ctaButtons a {
  margin: 1rem;
  }
}

@media (min-width: 561px) and (max-width:670px) {
.ctaButtons a {
  margin: 0.2rem;
  }
  .info-btn {
  padding: 10px;
}
}

@media (max-width: 560px) {
  .content {
    margin: 150px 30px 40px 30px;
  }
  .content .info h2 {
    font-size: 30px;
    line-height: 40px;
  }
  .content .info h2 span {
    font-size: 25px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .content .info p {
    font-size: 18px;
    text-align: left;
  }
  .card-deck .card {
    min-width: 220px;
    padding: 10px;
  }
  .media-icons {
    margin-bottom: 70px;
  }
  .media-icons a {
    margin-right: 20px;
  }
  .left_area {
    margin-left: 10px;
  }
  .left_area span {
    font-size: 2.3rem;
    letter-spacing: 1px;
  }
  .scrolling {
    padding: 10px;
  }
  .ctaButtons {
  display: flex;
  flex-direction: column;
}
  .ctaButtons a {
  margin: 0.5em;
  }
.hideMobile {
  display: none;
}
}

@media only screen and (min-device-width: 950px) and (max-device-width: 1625px) {
  header .navigation a {
    margin-right: 7px;
    font-size: 0.7rem;
    letter-spacing: 0px;
  }
  .media-icons {
    margin-bottom: 50px;
  }
  .navigation .login-btn {
    padding: 5px;
  }
  .navigation .trial-btn {
    padding: 5px;
  }
  .scrolling {
    padding: 5px 10px 5px 15px;
  }
  .left_area span {
    font-size: 1.5rem;
  }
}

@media only screen and (min-device-width: 950px) and (max-device-width: 1350px) {
  .left_area {
    width: 200px;
  }
  header {
    padding: 10px 10px 10px 50px;
  }
}
/* END OF HEADER / HERO syles */

/* SMARTPHONES LANDSCAPE */
@media only screen and (min-device-width: 480px) and (max-device-width: 820px) and (orientation: landscape) {
  .media-icons {
    margin-bottom: 50px;
  }
  .scrolling {
    padding: 5px 0px 5px 25px;
  }
  #check:checked ~ header .navigation a {
    margin-bottom: 15px;
  }
  header {
    padding: 10px 10px;
  }
  .content {
    margin: 100px 50px;
  }
}

/*iPad */

/* OUR SERVICE syles */

@media (min-width: 768px) {
  html {
    font-size: 16px;
  }
}
@media (min-width: 500px) {
  .mobileOnly {
    display: none;
  }
}

.container {
  max-width: 1300px;
}

.card-deck .card {
  min-width: 220px;
}

.border-top {
  border-top: 1px solid #e5e5e5;
}
.border-bottom {
  border-bottom: 1px solid #e5e5e5;
}

.box-shadow {
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
}

@media only screen and (min-device-width: 360px) and (max-device-width: 500px) and (orientation: portrait) {
  .info-btn {
    width: 250px;
    margin: auto;
}
}

@media only screen and (min-device-width: 320px) and (max-device-width: 359px) and (orientation: portrait) {
.content {
  margin: 110px 30px 0px 30px;
}
.content .info p {
  margin-bottom: 10px;
}
.info-btn {
  width: auto;
  letter-spacing: 0px;
}
}

@media only screen and (min-device-width: 280px) and (max-device-width: 320px) and (orientation: portrait) {
.content .info h2 {
  font-size: 24px;
}
}
</style>